export default "__VITE_ASSET__BhFPmQwG__"